import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=6bed2398&"
import script from "./AdminContainer.vue?vue&type=script&lang=js&"
export * from "./AdminContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports